module.exports = __webpack_public_path__ + "media/images/undraw/reserve/mobile_messages-a8623929262de4731cde8dc519929b73.png";